import React from "react"
import Slider from "react-slick"
import Img from "gatsby-image"
import { Link } from "./localizedlink"
import usePhotogallery from "../utility/usePhotogallery"
import { FormattedMessage } from "react-intl"


const settings = {
  dots: true,
  // autoplay: true,
  centerMode: true,
  pauseOnHover: false,
  // pauseOnDotsHover: true,
  speed: 500,
  autoplaySpeed: 10000,
  arrows: true,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        centerMode: false,
        slidesToShow: 1
      }
    }
  ]
};

const SliderGallery = () => {
  const images = usePhotogallery(true);

  return (
    <section id="slider-gallery" className="section text-center slider-gallery clearfix" aria-labelledby="slider-gallery">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-8 offset-md-2">
            <h1 id="region-slider-gallery" className="section__title" data-aos="fade-up">
              <FormattedMessage id="guarda-le-foto" />
            </h1>
            <div data-aos="fade-up">
              <div className="row">
                <div className="col-sm-12">
                  <Slider {...settings}>
                    {images.map((item, i) => (
                      <div key={i}>
                        <div className="slider-gallery__img-wrapper">
                          <Img fluid={item.slider} alt={item.name} />
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 text-center">
                  <Link to="/fotogallery/" alt="Photogallery" className="section__link">
                    <FormattedMessage id="guarda-tutte-le-foto" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SliderGallery;